import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ImportEstimation/helpers/useElementPropertyList.ts";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useStore, useStoreMap } from 'effector-react';
import { equals } from 'ramda';
import { isNumber } from '@gmini/utils';
import * as smApi from '@gmini/sm-api-sdk';
import { buildClsGroupKey } from "../../../Services/EstimationService";
import { importEstimationService } from "../model";
import { useSelectedGroupNode } from "./useSelectedGroupNode"; //TODO: Вынести из модулей код такой же код как ниже и переиспользовать тут

export function useElementPropertyList() {
  var currentClassifier = useStore(importEstimationService.activeCurrentClassifier$);
  var pending = useStore(smApi.UserClassifierGroup.Property.List.fetchElementProperties.defaultContext.pending$);
  var selectedGroup = useSelectedGroupNode({
    nodes$: importEstimationService.classifierService.nodes$
  });
  var propertyElementList = useStoreMap({
    store: importEstimationService.estimationService.elementProps.byKey$,
    keys: [currentClassifier === null || currentClassifier === void 0 ? void 0 : currentClassifier.id, currentClassifier === null || currentClassifier === void 0 ? void 0 : currentClassifier.version, selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.id],
    fn: function fn(byElementCalc, _ref) {
      var _ref2 = _slicedToArray(_ref, 3),
          classifierId = _ref2[0],
          classifierVersion = _ref2[1],
          groupId = _ref2[2];

      return isNumber(classifierId) && isNumber(classifierVersion) && isNumber(groupId) ? (byElementCalc === null || byElementCalc === void 0 ? void 0 : byElementCalc[buildClsGroupKey({
        classifierId: classifierId,
        groupId: groupId
      })]) || [] : [];
    },
    updateFilter: function updateFilter(newResult, oldResult) {
      return !equals(oldResult, newResult);
    }
  });
  return {
    propertyElementList: propertyElementList,
    pending: pending
  };
}